import { Button, Col, Typography } from "antd";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  useListCustomerGroups,
  WrapperModalListCustomerGroups,
} from "../../../../modules";
import {
  selectListCustomerGroupsForUpdate,
  selectIsUpdateListCustomerGroups,
  selectModalListCustomerGroups,
} from "../../../../redux";
import { DataListCustomerGroups } from "../../../../redux/@types";
import { BRAND } from "../../../theme/brand";
import { InputText } from "../inputs";

const { Title } = Typography;

export const ModalListCustomerGroups = () => {
  const modalListCustomerGroups = useSelector(selectModalListCustomerGroups);
  const isUpdateListCustomerGroups = useSelector(
    selectIsUpdateListCustomerGroups,
  );
  const updateListCustomerGroups = useSelector(
    selectListCustomerGroupsForUpdate,
  );

  const {
    isLoading,
    changeModalListCustomerGroupsState,
    onSubmitCreateOrUpdate,
  } = useListCustomerGroups();

  const { control, handleSubmit: onSubmit } =
    useFormContext<DataListCustomerGroups>();

  return (
    <WrapperModalListCustomerGroups
      title={
        <span style={{ fontSize: 18, fontWeight: 600 }}>
          {isUpdateListCustomerGroups
            ? `Editar grupo: ${updateListCustomerGroups?.name || updateListCustomerGroups?.id}`
            : "Nuevo grupo de clientes"}
        </span>
      }
      open={modalListCustomerGroups}
      width={420}
      placement="right"
      destroyOnClose
      onClose={changeModalListCustomerGroupsState}
      headerStyle={{ borderBottom: "1px solid #f0f0f0", padding: "16px 24px" }}
      bodyStyle={{ padding: 24, background: "#fafafa" }}
    >
      <Col
        span={24}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: 8 }} level={5}>
          Nombre
        </Title>
        <InputText
          placeHolder="Ej. Clientes VIP"
          name="name"
          control={control}
        />
      </Col>
      <Button
        type="primary"
        size="large"
        block
        loading={isLoading}
        onClick={onSubmit(onSubmitCreateOrUpdate)}
        style={{
          marginTop: 24,
          borderRadius: 30,
          height: 44,
          fontWeight: 600,
          boxShadow: BRAND.primaryShadow,
        }}
      >
        {isUpdateListCustomerGroups ? "Actualizar información" : "Crear grupo"}
      </Button>
    </WrapperModalListCustomerGroups>
  );
};
